/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CropReport } from '../models/crop-report';
import { deleteCropReport } from '../fn/crop-report/delete-crop-report';
import { DeleteCropReport$Params } from '../fn/crop-report/delete-crop-report';
import { getCropReportByCropIdx } from '../fn/crop-report/get-crop-report-by-crop-idx';
import { GetCropReportByCropIdx$Params } from '../fn/crop-report/get-crop-report-by-crop-idx';
import { getCropReportByFacilityGroupId } from '../fn/crop-report/get-crop-report-by-facility-group-id';
import { GetCropReportByFacilityGroupId$Params } from '../fn/crop-report/get-crop-report-by-facility-group-id';
import { getCropReportByFacilityId } from '../fn/crop-report/get-crop-report-by-facility-id';
import { GetCropReportByFacilityId$Params } from '../fn/crop-report/get-crop-report-by-facility-id';
import { getCropReportByReportId } from '../fn/crop-report/get-crop-report-by-report-id';
import { GetCropReportByReportId$Params } from '../fn/crop-report/get-crop-report-by-report-id';
import { triggerCropReportCreation } from '../fn/crop-report/trigger-crop-report-creation';
import { TriggerCropReportCreation$Params } from '../fn/crop-report/trigger-crop-report-creation';
import { updateCropReport } from '../fn/crop-report/update-crop-report';
import { UpdateCropReport$Params } from '../fn/crop-report/update-crop-report';

@Injectable({ providedIn: 'root' })
export class CropReportService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `triggerCropReportCreation()` */
  static readonly TriggerCropReportCreationPath = '/api/cropreport';

  /**
   * Trigger Crop Report Creation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `triggerCropReportCreation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  triggerCropReportCreation$Response(params: TriggerCropReportCreation$Params, context?: HttpContext): Observable<StrictHttpResponse<CropReport>> {
    return triggerCropReportCreation(this.http, this.rootUrl, params, context);
  }

  /**
   * Trigger Crop Report Creation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `triggerCropReportCreation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  triggerCropReportCreation(params: TriggerCropReportCreation$Params, context?: HttpContext): Observable<CropReport> {
    return this.triggerCropReportCreation$Response(params, context).pipe(
      map((r: StrictHttpResponse<CropReport>): CropReport => r.body)
    );
  }

  /** Path part for operation `getCropReportByFacilityId()` */
  static readonly GetCropReportByFacilityIdPath = '/api/cropreport/facility/{facilityId}';

  /**
   * Get Crop Report By Facility Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCropReportByFacilityId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCropReportByFacilityId$Response(params: GetCropReportByFacilityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CropReport>>> {
    return getCropReportByFacilityId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Crop Report By Facility Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCropReportByFacilityId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCropReportByFacilityId(params: GetCropReportByFacilityId$Params, context?: HttpContext): Observable<Array<CropReport>> {
    return this.getCropReportByFacilityId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CropReport>>): Array<CropReport> => r.body)
    );
  }

  /** Path part for operation `getCropReportByCropIdx()` */
  static readonly GetCropReportByCropIdxPath = '/api/cropreport/facility/{facilityId}/idx/{cropIdx}';

  /**
   * Get Crop Report By Crop Idx.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCropReportByCropIdx()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCropReportByCropIdx$Response(params: GetCropReportByCropIdx$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CropReport>>> {
    return getCropReportByCropIdx(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Crop Report By Crop Idx.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCropReportByCropIdx$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCropReportByCropIdx(params: GetCropReportByCropIdx$Params, context?: HttpContext): Observable<Array<CropReport>> {
    return this.getCropReportByCropIdx$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CropReport>>): Array<CropReport> => r.body)
    );
  }

  /** Path part for operation `getCropReportByFacilityGroupId()` */
  static readonly GetCropReportByFacilityGroupIdPath = '/api/cropreport/facilityGroup/{facilityGroupId}';

  /**
   * Get Crop Report By Facility Group Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCropReportByFacilityGroupId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCropReportByFacilityGroupId$Response(params: GetCropReportByFacilityGroupId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CropReport>>> {
    return getCropReportByFacilityGroupId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Crop Report By Facility Group Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCropReportByFacilityGroupId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCropReportByFacilityGroupId(params: GetCropReportByFacilityGroupId$Params, context?: HttpContext): Observable<Array<CropReport>> {
    return this.getCropReportByFacilityGroupId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CropReport>>): Array<CropReport> => r.body)
    );
  }

  /** Path part for operation `getCropReportByReportId()` */
  static readonly GetCropReportByReportIdPath = '/api/cropreport/{cropReportId}';

  /**
   * Get Crop Report By Report Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCropReportByReportId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCropReportByReportId$Response(params: GetCropReportByReportId$Params, context?: HttpContext): Observable<StrictHttpResponse<CropReport>> {
    return getCropReportByReportId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Crop Report By Report Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCropReportByReportId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCropReportByReportId(params: GetCropReportByReportId$Params, context?: HttpContext): Observable<CropReport> {
    return this.getCropReportByReportId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CropReport>): CropReport => r.body)
    );
  }

  /** Path part for operation `updateCropReport()` */
  static readonly UpdateCropReportPath = '/api/cropreport/{cropReportId}';

  /**
   * Update Crop Report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCropReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCropReport$Response(params: UpdateCropReport$Params, context?: HttpContext): Observable<StrictHttpResponse<CropReport>> {
    return updateCropReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Crop Report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCropReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCropReport(params: UpdateCropReport$Params, context?: HttpContext): Observable<CropReport> {
    return this.updateCropReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<CropReport>): CropReport => r.body)
    );
  }

  /** Path part for operation `deleteCropReport()` */
  static readonly DeleteCropReportPath = '/api/cropreport/{cropReportId}';

  /**
   * Delete Crop Report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCropReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCropReport$Response(params: DeleteCropReport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCropReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Crop Report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCropReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCropReport(params: DeleteCropReport$Params, context?: HttpContext): Observable<void> {
    return this.deleteCropReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
